module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="user-data-box">\n	<figure>\n		<img src="'+
((__t=( avatar_url ))==null?'':_.escape(__t))+
'" alt="">\n	</figure>\n	';
 if(tipping_team_name){ 
__p+='\n		<h3>'+
((__t=( tipping_team_name ))==null?'':_.escape(__t))+
'</h3>\n	';
 } 
__p+='\n</div>\n\n\n';
 if(show_rank){ 
__p+='\n	<div class="tipping-user-snapshot">\n		<div class="data-column ">\n				<div class="title">RND TIPS</div>\n				<div class="data-column">\n					<div class="value">'+
((__t=( round_points === 0 ? '-' : round_points ))==null?'':_.escape(__t))+
'</div>\n					<div class="data-total">	\n						/'+
((__t=( total_tips_count ))==null?'':_.escape(__t))+
'\n					</div>\n				</div>\n		</div>\n		<div class="data-column hidden-mobile">\n			<div class="title">TOTAL TIPS</div>\n			<div class="data-column">\n				<div class="value">'+
((__t=( total_points ))==null?'':_.escape(__t))+
'</div>\n				<div class="data-total">\n					/'+
((__t=( total_tips_possible ))==null?'':_.escape(__t))+
'\n				</div>\n			</div>\n		</div>\n		<div class="data-column">\n			<div class="title">OVERALL RANK</div>\n			<div class="data-column">\n				<div class="value">\n					'+
((__t=( overall_rank === 0 ? '-' : overall_rank ))==null?'':_.escape(__t))+
'\n				</div>\n				<div class="data-total">\n					/ '+
((__t=( total_ranked_users ))==null?'':_.escape(__t))+
'\n				</div>\n			</div>\n		</div>\n		<div class="data-column hidden-mobile">\n			<div class="title">MARGIN TOTAL</div>\n			<div class="value">'+
((__t=( total_margin ))==null?'':_.escape(__t))+
'</div>\n			<div class="data-total">\n					\n			</div>\n		</div>\n	</div>\n';
 } 
__p+='\n\n\n<div class="social-sharing-box hidden">\n	<a class="share share-fb js-share-fb js-sharing" data-type="fb">\n		<i class="icon ion-social-facebook"></i>\n	</a>\n	<a class="share share-tw js-share-tw js-sharing" data-type="tw">\n		<i class="icon ion-social-twitter"></i>\n	</a>\n</div>\n\n';
 if(_.size(rounds)){ 
__p+='\n	<div class="select-wrapper inner-element">\n		<select name="rounds" id="rounds-select" class="base-select">\n			';
 _.each(rounds, function ( round ) { 
__p+='\n				<option value="'+
((__t=( round.id ))==null?'':_.escape(__t))+
'" '+
((__t=( round.id == selected_round ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n					'+
((__t=( 'Round ' + round.id ))==null?'':_.escape(__t))+
'\n				</option>\n			';
 }) 
__p+='\n		</select>\n	</div>\n';
 } 
__p+='\n';
}
return __p;
};
